export const convertToBrazilDate = (isoDateString) => {
  const date = new Date(isoDateString);

  const options = {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  // eslint-disable-next-line no-undef
  const formatter = new Intl.DateTimeFormat("pt-BR", options);
  const formattedDate = formatter.format(date);

  return formattedDate;
};
